import styled, { keyframes, css } from "styled-components";

export const PortfolioBuilderContainer = styled.div`
  padding: 0px 0px;
  margin-top: 20px;

  .advanced-placeholder {
    text-align: center;
    padding: 60px 20px;
    color: #6c757d;
    font-size: 18px;
  }
`;
export const CompanyLogo = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 8px;
`;
export const CompanyDetailsContainer = styled.div`
  border-radius: 8px;
  font-family: "Geist", sans-serif;
`;
export const TabsSwitcherContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  border-radius: 8px;
  border: 1px solid #e9eaeb;
  background: #fafafa;

  .tab-button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 12px;
    border-radius: 8px;
    color: #717680;
    border: 1px solid transparent;
    background: transparent;
    cursor: pointer;
    transition: all 0.2s;
    font-family: "Public Sans", sans-serif;
    line-height: 20px;
  }

  .tab-button.active {
    color: #414651;
    border: 1px solid #d5d7da;
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  }

  &.underline {
    gap: 2px;
    border: none;
    background: transparent;
    position: relative;
    width: 100%;
    padding: 0 14px;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: #00000012;
    }

    .tab-button {
      flex: 1 1 0;
      border: none;
      border-radius: 0;
      background: transparent;
      color: #717680;
      font-family: "Geist", sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      padding: 12px 36px;
      text-align: center;
      position: relative;
    }

    .tab-button.active {
      color: #1841dd;
      border: none;
      background: transparent;
      box-shadow: none;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 1px;
        width: 100%;
        height: 2px;
        background: #1841dd;
      }
    }
  }
`;
export const StrategySection = styled.div`
  background: #fff;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  padding: 16px;
  margin-top: 20px;
`;
export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    color: #181d27;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
  }

  .des {
    font-size: 14px;
    color: #535862;
    font-weight: 400;
    margin-bottom: 0px;
  }
`;
export const AllocationInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;
export const AllocationInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  h3 {
    color: #535862;
    text-align: right;
    font-size: 10px;
    font-weight: 400;
    margin-bottom: 0px;
  }

  span {
    color: #181d27;
    text-align: right;
    font-size: 14px;
    font-weight: 500;
  }
  .remaining-text {
    color: #1841dd;
  }

  .progress-text {
    span {
      color: #717680;
      font-size: 10px;
    }
  }
`;
export const Divider = styled.div`
  width: 1px;
  height: 38px;
  background: #e9eaeb;
`;
export const DynamicDetailsContainer = styled.div`
  display: flex;
  column-gap: 4px;
  row-gap: 20px;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 34px;
`;
export const ChartItemContainer = styled.div`
  width: 153px;
  /* width: ${(props) => props.width}%; */
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
export const BarSegment = styled.div`
  background-color: ${(props) => props.color};
  border-radius: 3px;
  width: 100%;
  height: 12px;
  transition: width 0.3s ease-out;
`;
export const FlexItemWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  background-color: white;
`;
export const TopColorStrip = styled.div`
  width: 4px;
  height: 100%;
  background-color: ${(props) => props.color};
  position: absolute;
  // bottom: 0;
  left: 0;
`;
export const StockName = styled.p`
  color: #414651;
  font-size: 12px;
  font-weight: 400;
  font-family: "Geist", sans-serif;
  margin: 10px 0px 0px;
`;
export const AllocationPercentage = styled.p`
  font-size: 10px;
  font-weight: 400;
  color: #717680;
  font-family: "Geist", sans-serif;
  margin: 0px 0px 10px;
`;
export const ControlButtonsContainer = styled.div`
  display: flex;
  border-radius: 8px;
  border: 1px solid #d5d7da;
  box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
    rgba(10, 13, 18, 0.05) inset, 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  margin-top: 20px;
  overflow: hidden;
`;
export const ControlButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 10px;
  border: none;
  font-size: 12px;
  font-weight: 500;
  font-family: "Geist", sans-serif;
  background: white;
  color: #414651;
  cursor: pointer;
  transition: all 0.2s;

  &[data-active="true"] {
    background: #fafafa;
    color: #252b37;
  }

  &:disabled {
    background: #f5f7fa;
    color: #9da3ae;
    cursor: not-allowed;
    box-shadow: none;
  }
`;
export const ControlDivider = styled.div`
  width: 1px;
  height: 34px;
  background: #d5d7da;
`;
export const TableWrapper = styled.div`
  max-height: 400px;
  position: relative;
  margin-top: 16px;
  /* padding-top: 24px; */
  overflow-y: auto;
  z-index: 20;

  .table-container {
    border: 1px solid #e9eaeb;
    /* border-radius: 12px; */

    .table-wrapper {
      border-radius: 12px !important;
      box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
      border: none;

      .table-row {
        border: none;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;

        .header-content {
          color: #717680;
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
        }

        th {
          border-top-left-radius: 12px;
          border-top-right-radius: 12px;
          border-bottom: 1px solid #e9eaeb;
          background: none;
        }

        th:nth-child(1) {
          width: 70%;
        }
      }

      .active-row {
        border-bottom: 1px solid #e9eaeb !important;
      }

      .table-cell {
        padding: 15px 16px;
        border-bottom: red;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
    }
  }
`;
export const WarningMessage = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  color: #1841dd;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  background: #eff5ff;
  border-top: 1px solid #3677fb;
  border-right: 1px solid #3677fb;
  border-left: 1px solid #3677fb;
  border-radius: 6px 6px 0 0;
  padding: 6px 12px 12px;
  z-index: 100;
`;
export const AddEquallyButton = styled.button`
  font-size: 1opx;
  color: #1841dd;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;

  &:disabled {
    color: #9da3ae;
    cursor: not-allowed;
  }
`;
export const NoCompanyAdd = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e9eaeb;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
`;
export const WeightInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const WeightInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #d5d7da;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);

  &[data-disabled="true"],
  &[aria-disabled="true"] {
    border-color: #e9eaeb;
    background: #fafafa;
  }

  input:disabled {
    background: #fafafa;
    color: #9da3ae;
    cursor: not-allowed;
  }

  input:disabled + span {
    border-left-color: #e9eaeb;
    color: #9da3ae;
    background: #fafafa;
  }
`;
export const WeightInput = styled.input`
  width: 84px;
  height: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #181d27;
  font-family: "Geist", sans-serif;
  border: none;
  outline: none;
  line-height: 18px;
  padding: 6px 5px 6px 12px;
  border-radius: 8px 0 0px 8px;

  &:disabled {
    background: #fafafa;
    color: #9da3ae;
    cursor: not-allowed;
  }
`;
export const WeightInputSuffix = styled.span`
  flex-shrink: 0;
  min-width: 0;
  font-size: 14px;
  font-family: "Geist", sans-serif;
  font-weight: 500;
  color: #535862;
  border-radius: 0 8px 8px 0;
  border-left: 1px solid #d5d7da;
  padding: 6px 7px 6px 12px;
  line-height: 20px;
`;
export const ActionButton = styled.button`
  width: 100%;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;

    svg {
      opacity: 0.5;
    }
  }
`;
export const CounterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
    0 -1px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  cursor: pointer;

  &:disabled {
    background: #f5f7fa;
    border: 1px solid #e9eaeb;
    cursor: not-allowed;
    box-shadow: none;
  }
`;
export const RulesSection = styled.div`
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #e9eaeb;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  margin-top: 20px;

  .rules-title {
    font-size: 14px;
    font-weight: 500;
    color: #181d27;
    margin: 0;
  }
  .rules-description {
    font-size: 14px;
    font-weight: 400;
    color: #535862;
    line-height: 20px;
    margin: 4px 0px 0px;
  }
`;
export const RuleCardWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
`;
export const RuleCard = styled.button`
  max-width: 300px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fafafa;
  color: #414651;
  cursor: pointer;
  transition: all 0.2s ease;

  &[data-active="true"] {
    border: 1px solid rgba(255, 255, 255, 0.6);
    background: linear-gradient(180deg, #f5f5f5 0%, #e9eaeb 100%);
    box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
      0 -1px 0 0 rgba(10, 13, 18, 0.05) inset,
      0 1px 2px 0 rgba(10, 13, 18, 0.05);
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
export const RuleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;

  .rule-details {
    .rule-title {
      color: #181d27;
      font-size: 14px;
      font-weight: 500;
    }
    .rule-desc {
      color: #535862;
      font-size: 12px;
      font-weight: 18px;
      padding-top: 2px;
      margin: 0;
    }
  }
`;
export const MenuButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
`;
export const AddRuleCard = styled.button`
  max-width: 300px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  color: #414651;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  padding: 14px 12px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fafafa;

  &:disabled {
    color: #9da3ae;
    cursor: not-allowed;
  }
`;
export const AlertMessage = styled.p`
  position: sticky;
  bottom: 0;
  width: 100%;
  font-size: 12px;
  color: #c02424;
  font-weight: 500;
  padding: 8px 12px;
  margin-bottom: 0px;
  background: #ffecec;
  border-left: 1px solid #ff9b9b;
  border-right: 1px solid #ff9b9b;
  border-bottom: 1px solid #ff9b9b;
  border-radius: 0 0 6px 6px;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const RotatingIcon = styled.span`
  display: inline-flex;
  align-items: center;
  /* Apply rotation animation only when $spinning is true */
  ${({ $spinning }) =>
    $spinning &&
    css`
      animation: ${rotate} 1s linear infinite;
    `}
`;
